<template>
  <v-app>
    <div v-if="isLandingPage">
      <router-view />
    </div>

    <v-main
      v-else
      class="mainContainer"
    >
      <div class="leftMenu">
        <LeftMenu />
      </div>
      <div class="content-cont">
        <InteractionMode />
        <AppBreadcrumbs />
        <div class="content">
          <router-view />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import InteractionMode from '@/components/widget/InteractionMode.vue';
  import LeftMenu from '@/components/nav/LeftMenu.vue';
  import { useSubjectStore } from '@/store/subjectStore';
  import { onKeycloakReady } from '@/plugins/keycloak';
  import AppBreadcrumbs from '@/components/widget/AppBreadcrumbs.vue';

  const subjectStore = useSubjectStore();
  const route = useRoute();
  const isLandingPage = computed(() => route.path.includes('/landing'));

  onMounted(async () => {
    await onKeycloakReady();
    await subjectStore.fetchSelectedSubject();
  });
</script>

<style lang="scss">
  .mainContainer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;

    .leftMenu {
      width: 290px;
    }
    .content-cont {
      width: calc(100% - 290px);
    }
  }
</style>
